<app-loader [isLoading]="isLoading"></app-loader>

<div class="header form-header">
    <div class="top">
        <a routerLink="/home/users/list/">
            <h3>Roles de Usuario /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{externalId}}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content">


    <!-- <div class="filter-container">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Buscar roles</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Nombre o descripción">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div> -->

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
            class="mat-elevation-z8 table">

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre del Rol</th>
                <td mat-cell *matCellDef="let role">{{role.name}}</td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
                <td mat-cell *matCellDef="let role" [innerHTML]="sanitizeHtml(role.description)"></td>
            </ng-container>

            <!-- Assigned Column -->
            <ng-container matColumnDef="assigned">
                <th mat-header-cell *matHeaderCellDef>Asignado</th>
                <td mat-cell *matCellDef="let role">
                    <mat-checkbox [checked]="role.assigned" (change)="toggleRoleAssignment(role)" color="primary">
                    </mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator> -->
    </div>

    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveRoleAssignments()">Guardar Cambios</button>
        <button mat-flat-button id="cancel" (click)="goBack()">Cancelar</button>
    </div>
</div>